import React from "react";
import PropTypes from "prop-types";
import DesafioDesktop from "./DesafioDesktop";

function Desafio({ app, config }) {
  return <DesafioDesktop app={app} config={config} />;
}

Desafio.defaultProps = {
  app: null,
  config: {},
};

Desafio.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Desafio;
